module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-gray"
  }, [_c('div', {
    staticClass: "form-content"
  }, [_c('el-divider', [_vm._v("我加入的俱乐部")]), _vm._v(" "), (_vm.row.club.length > 0) ? _c('div', [_c('el-table', {
    ref: "clubTable",
    attrs: {
      "data": _vm.row.club,
      "row-key": "id",
      "show-header": false
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "单位名称",
      "fixed": "left",
      "prop": "title"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.row.danwei) + "\n          ")]
      }
    }], null, false, 116507853)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "prop": "zhuantai"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.registstatus == 1) ? _c('el-tag', [_vm._v("\n              等待审核\n            ")]) : (scope.row.registstatus == 2) ? _c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("\n              审核成功\n            ")]) : (scope.row.registstatus == 3) ? _c('el-tag', [_vm._v("\n              审核失败\n            ")]) : _vm._e()]
      }
    }], null, false, 3962440717)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "日期",
      "prop": "riqi"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.row.create_time_str) + "\n          ")]
      }
    }], null, false, 1170675833)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "prop": "caozuo"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          staticClass: "look-order",
          attrs: {
            "size": "medium"
          },
          on: {
            "click": function($event) {
              return _vm.toClubNext(scope.row.id)
            }
          }
        }, [_vm._v("查看详情")])]
      }
    }], null, false, 2731629026)
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-divider', [_vm._v("我的考级中心（点）")]), _vm._v(" "), (_vm.row.exame_center.length > 0) ? _c('div', [_c('el-table', {
    ref: "exammeTable",
    attrs: {
      "data": _vm.row.exame_center,
      "row-key": "id",
      "show-header": false
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "单位名称",
      "fixed": "left",
      "prop": "title"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.row.danwei) + "\n          ")]
      }
    }], null, false, 116507853)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "prop": "zhuantai"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.kaojiregist_status == 1) ? _c('el-tag', [_vm._v("\n              等待审核\n            ")]) : (scope.row.kaojiregist_status == 2) ? _c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("\n              审核成功\n            ")]) : (scope.row.kaojiregist_status == 3) ? _c('el-tag', [_vm._v("\n              审核失败\n            ")]) : _vm._e()]
      }
    }], null, false, 454682036)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "日期",
      "prop": "riqi"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.row.create_time_str) + "\n          ")]
      }
    }], null, false, 1170675833)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "prop": "caozuo"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          directives: [{
            name: "rblink",
            rawName: "v-rblink",
            value: ({
              name: 'QcxjDetail',
              query: {
                id: scope.row.id
              }
            }),
            expression: "{name: 'QcxjDetail', query: {id: scope.row.id}}"
          }],
          staticClass: "look-order",
          attrs: {
            "size": "medium"
          }
        }, [_vm._v("查看详情")]), _vm._v(" "), _c('el-button', {
          staticClass: "look-order",
          attrs: {
            "size": "medium"
          },
          on: {
            "click": function($event) {
              return _vm.toKaojiNext(scope.row.id)
            }
          }
        }, [_vm._v("确认验收信息")])]
      }
    }], null, false, 893960494)
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-divider', [_vm._v("已有俱乐部/考级中心/考级点")]), _vm._v(" "), _c('div', {
    staticClass: "tc"
  }, [_c('el-row', [_c('el-button', {
    attrs: {
      "round": ""
    },
    on: {
      "click": _vm.toClub
    }
  }, [_vm._v("创建俱乐部")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "round": ""
    },
    on: {
      "click": _vm.toKaoji
    }
  }, [_vm._v("创建考级中心/考级点")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "round": ""
    },
    on: {
      "click": _vm.toAuth
    }
  }, [_vm._v("点击认证已有俱乐部/考级中心/考级点")])], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.clubShow,
      "title": "创建须知"
    },
    on: {
      "update:visible": function($event) {
        _vm.clubShow = $event
      }
    }
  }, [_c('div', {
    staticClass: "dialog-content"
  }, [_c('div', {
    staticClass: "dialog-step-li"
  }, [_vm._v("1.申请成为会员单位后，即成为一星俱乐部；")]), _vm._v(" "), _c('div', {
    staticClass: "dialog-step-li"
  }, [_vm._v("2.俱乐部升级类别")]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "dialog-li"
  }, [_c('div', {
    staticClass: "li-left"
  }, [_vm._v("（1）二星俱乐部")])]), _vm._v(" "), _c('li', {
    staticClass: "dialog-li"
  }, [_c('div', {
    staticClass: "li-left"
  }, [_vm._v("（2）三星俱乐部")])]), _vm._v(" "), _c('li', {
    staticClass: "dialog-li"
  }, [_c('div', {
    staticClass: "li-left"
  }, [_vm._v("（3）四星俱乐部")])]), _vm._v(" "), _c('li', {
    staticClass: "dialog-li"
  }, [_c('div', {
    staticClass: "li-left"
  }, [_vm._v("（4）五星俱乐部")])])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-step-li"
  }, [_c('div', [_vm._v("3.附件下载")]), _vm._v(" "), _c('el-link', {
    on: {
      "click": function($event) {
        return _vm.download('啦啦操星级俱乐部管理办法', 'https://ccago.oss-cn-hangzhou.aliyuncs.com/uploader/000/user-xxx/vc-upload-1623833117774-11.pdf')
      }
    }
  }, [_vm._v("\n          啦啦操星级俱乐部管理办法\n        ")])], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.clubShow = false
      }
    }
  }, [_vm._v("我再想想")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.toClubNext(0)
      }
    }
  }, [_vm._v("我已阅读并同意遵守本须知声明的所有条款 点击进行创建")])], 1)])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.kaojiShow,
      "title": "创建须知"
    },
    on: {
      "update:visible": function($event) {
        _vm.kaojiShow = $event
      }
    }
  }, [_c('div', {
    staticClass: "dialog-content"
  }, [_c('div', {
    staticClass: "dialog-step-li"
  }, [_vm._v("1.可创建类型为：")]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "dialog-li"
  }, [_c('div', {
    staticClass: "li-left"
  }, [_vm._v("（1）七彩星级指定考级点")]), _vm._v(" "), _c('div', {
    staticClass: "li-right"
  }, [_vm._v("0元")])]), _vm._v(" "), _c('li', {
    staticClass: "dialog-li"
  }, [_c('div', {
    staticClass: "li-left"
  }, [_vm._v("（2）七彩星级指定样板考级点")]), _vm._v(" "), _c('div', {
    staticClass: "li-right"
  }, [_vm._v("9800元")])]), _vm._v(" "), _c('li', {
    staticClass: "dialog-li"
  }, [_c('div', {
    staticClass: "li-left"
  }, [_vm._v("（3）七彩星级指定考级中心")]), _vm._v(" "), _c('div', {
    staticClass: "li-right"
  }, [_vm._v("120000元")])]), _vm._v(" "), _c('li', {
    staticClass: "dialog-li"
  }, [_c('div', {
    staticClass: "li-left"
  }, [_vm._v("（4）七彩星级指定样板考级中心")]), _vm._v(" "), _c('div', {
    staticClass: "li-right"
  }, [_vm._v("135000元")])])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-step-li"
  }, [_vm._v("2.请确认您已准备好营业执照扫描件（.jpg或.png）/根据我们APP可以接收的图片格式进行设定/")]), _vm._v(" "), _c('div', [_vm._v("3.附件下载")]), _vm._v(" "), _c('div', {
    staticClass: "dialog-step-li"
  }, [_c('el-link', {
    on: {
      "click": function($event) {
        return _vm.download('啦啦操七彩星级管理办法', 'https://ccago.oss-cn-hangzhou.aliyuncs.com/uploader/000/user-xxx/vc-upload-1622687436968-14.pdf')
      }
    }
  }, [_vm._v("\n          啦啦操七彩星级管理办法\n        ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-step-li"
  }, [_c('el-link', {
    on: {
      "click": function($event) {
        return _vm.download('七彩星级考级中心（点）加盟方案', 'https://ccago.oss-cn-hangzhou.aliyuncs.com/uploader/000/user-xxx/vc-upload-1622687436968-12.pdf')
      }
    }
  }, [_vm._v("\n          七彩星级考级中心（点）加盟方案\n        ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-step-li"
  }, [_c('el-link', {
    on: {
      "click": function($event) {
        return _vm.download('考级点文化包（兼容版）', 'https://ccago.oss-cn-hangzhou.aliyuncs.com/uploader/000/user-xxx/vc-upload-1622700945764-10.zip')
      }
    }
  }, [_vm._v("\n          考级点文化包（兼容版）请下载制作\n        ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-step-li"
  }, [_c('el-link', {
    on: {
      "click": function($event) {
        return _vm.download('考级中心文化包（兼容版）', 'https://ccago.oss-cn-hangzhou.aliyuncs.com/uploader/000/user-xxx/vc-upload-1622700945764-12.zip')
      }
    }
  }, [_vm._v("\n          考级中心文化包（兼容版）请下载制作\n        ")])], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.kaojiShow = false
      }
    }
  }, [_vm._v("我再想想")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.toKaojiNext(0)
      }
    }
  }, [_vm._v("我已阅读并同意遵守本须知声明的所有条款 点击进行创建")])], 1)])]), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-35af49dd","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/club/ClubIndex.vue
// module id = 1447
// module chunks = 0